import { render, staticRenderFns } from "./CMAttachmentsCreateRefund.vue?vue&type=template&id=7e97aef0&scoped=true&"
import script from "./CMAttachmentsCreateRefund.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsCreateRefund.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsCreateRefund.vue?vue&type=style&index=0&id=7e97aef0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e97aef0",
  null
  
)

export default component.exports